import ScreenreaderOnlyText from "./ScreenreaderOnlyText";

export default ScreenreaderOnlyText;
